import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AttributeInterface } from 'src/app/model/attributes/attribute-interface';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';

@Component({
    selector: 'attribute-validation-table',
    templateUrl: './attribute-validation-table.component.html',
    styleUrls: ['./attribute-validation-table.component.css'],
    standalone: false
})
export class AttributeValidationTableComponent implements OnInit {
    @Input() editable?: boolean;

    @Input() optional?: boolean;

    @Input() set attributes(attributes: AttributeInterface[]) {
        this.attributes_ = attributes;
        this.attributes_.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
    }

    get attributes(): AttributeInterface[] {
        return this.attributes_;
    }

    private attributes_: AttributeInterface[];

    @Output() attributesChanged: EventEmitter<AttributeInterface[]> =
        new EventEmitter<AttributeInterface[]>();

    constructor(
        public attributeValidationService: AttributeValidationServiceService,
        public productService: ProductService,
        public certificationService: CertificationService
    ) {}

    ngOnInit(): void {
        this.attributeValidationService.loadValidation(
            this.attributes,
            this.optional
        );
    }

    removeAttribute(attribute: AttributeInterface): void {
        const validationId = attribute.validations[0].id;
        this.attributes = this.attributes.filter((attribute) => {
            return attribute.validations[0].id !== validationId;
        });
        this.attributesChanged.emit(this.attributes);
    }

    public hasAttributeConflict(attribute: AttributeInterface): boolean {
        return this.attributeValidationService.hasAttributeConflict(
            attribute.id
        );
    }

    public getConflictErrorMessage(attribute: AttributeInterface): string {
        const isOptional =
            this.attributeValidationService.isAttributeEffectivelyOptional(
                attribute.id
            );
        const attributeName = attribute.name;
        let conflictMessage =
            'Es wurden mehrere Validierungen für das Merkmal ' +
            attributeName +
            ' ausgewählt, welche nicht gleichzeitig erfüllt werden können.';
        if (isOptional) {
            conflictMessage +=
                ' Da es sich um ein optionales Merkmal handelt, ist nur keine Angabe valide';
        }
        return conflictMessage;
    }

    onAttributeValueChange(
        attribute: AttributeInterface,
        newValue: string
    ): void {
        this.attributeValidationService.modelChangedIsOptional(
            attribute,
            attribute.validations[0],
            newValue
        );
    }
}
